import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducer from "../reducers";
import promiseMiddleware from "../../../../utils/promiseMiddleware";

const middlewares = [promiseMiddleware, thunk];

export default function configureStore(initialState) {
  return createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middlewares)
  );
}



// WEBPACK FOOTER //
// ./src/components/app/store/configureStore.prod.js